<script setup lang="ts">
import type { RouteParams } from 'vue-router'
import type { PremiumDonate } from '@store'

defineOptions({
  inheritAttrs: false,
})

const { hide: modalHide } = useModal()
const { t } = useI18n()
const show = ref(false)
const isLoading = ref(false)
const isFail = ref(false)
const payload = ref<PremiumDonate>()

// 모달 오픈전 사전 작업 수행
const handleOnBeforeOpen = (evt: RouteParams) => {
  payload.value = evt.value as unknown as PremiumDonate
}

// 모달 닫기
const handleOnClose = async () => {
  payload.value = undefined
  await modalHide(modalsName.MODAL_PAY)
}
</script>

<template>
  <VueFinalModal
    v-model="show"
    :name="modalsName.MODAL_PAY"
    :content-class="'modal-content'"
    classes="modal-container"
    @before-open="(evt: any) => handleOnBeforeOpen(evt.ref.params)"
    @closed="handleOnClose"
    @click-outside="handleOnClose"
  >
    <ClientOnly>
      <NovaLoadingIndicator
        v-if="isLoading"
        :fill="true"
        :bg-bright="'dark'"
        class="async-status-message"
      />

      <NovaBoxBase v-if="!isLoading && show" class="modal-box">
        <div class="modal-header">
          <h4 class="title"></h4>

          <NovaButtonIcon
            :icon="{ type: 'outline', name: 'close-extend' }"
            :theme="'transparent'"
            :size="20"
            class="btn-close"
            @click="handleOnClose"
          />
        </div>

        <div class="modal-body">
          <NovaIframeContainer
            v-if="payload"
            :url="payload.url"
            :height="625"
          />

          <NovaBoxEmptyMessage
            v-if="isFail"
            :message="t('pay.iframe.loadFail')"
            :fill="true"
            class="async-status-message"
          />
        </div>
      </NovaBoxBase>
    </ClientOnly>
  </VueFinalModal>
</template>

<style lang="scss" scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.vfm--overlay) {
  background-color: hex-to-rgba($color-black, 0.65);
}

:deep(.modal-content) {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .modal-box {
    width: 100%;
    height: auto;
    max-width: 420px;
    max-height: calc(100% - 24px - 24px);
    padding: 0;
    pointer-events: auto;
    overflow: hidden;

    .modal-header {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      padding: 0 20px;
      color: $color-text-2;
      background-color: $color-bg-3;
      border-bottom: 1px solid $border-1;

      .title {
        @include text-style($text-display-bold);
      }
    }

    .modal-body {
      width: 100%;
      height: 100%;
      max-height: 625px;
      overflow: auto;
    }

    @include mobile {
      flex-grow: 1;
      border-radius: 0 !important;
      max-width: 100%;
      height: 100%;
      max-height: 100%;
    }
  }
}
</style>
